<template>
  <v-app id="inspire" class="fontLao">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>ໂປຣໂມຊັນພິເສດສໍາລັບລູກຄ້າຕາມຈໍານວນ</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="ຊອກຫາ" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <v-btn slot="activator" color="primary" dark class="mb-2">ເພີ່ມ</v-btn>
          <v-card>
            <v-card-title>
            <span class="headline fontLao">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap class="fontLao">
                  <v-flex xs12 sm12 md12 >
                    <v-text-field v-model="editedItem.qty" type="number" min=1 label="ຈຳນວນ"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.price" type="number" min=1 label="ລາຄາ"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer >
              <v-btn color="blue darken-1" flat @click.native="close" class="fontLao">ຍົກເລີກ</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save" class="fontLao">ບັນທືກ</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table :headers="headers" :items="mydata" :search="search" :rows-per-page-items=[10,20,50,100,500] class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ _P(props.item.qty) }}</td>
          <td>{{ _P(props.item.price) }}</td>
          <td class="text-xs-center px-0">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon> 
            <v-icon small @click="deleteItem(props.item)" > delete </v-icon>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">ກົດເລີ່ມໃໝ່</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-app>
</template>
<script>
import db from '@/firebase/init'
  export default {
    name:'customproductpricecount',
    data: () => ({
      dialog: false,
      search: '',
      headers: [
        {text: 'ຈໍານວນຂັ້ນຕໍ່າ', value: 'qty' ,align: 'left'},
        {text: 'ລາຄາຂາຍໃຫ້ລູກຄ້າ', value: 'price' ,align: 'left'},
        {text: 'ການເຄື່ອນໄຫວ', value: 'action', sortable: false,align: 'center'}
      ],
      mydata: [],
      editedIndex: -1,
      editedItem: {
        qty: 2,
        price: 1,
        stt:1
      },
      defaultItem: {
        qty: 2,
        price: 1,
        stt:1
      }
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'ເພີ່ມ' : 'ແກ້ໄຂ'
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    created () {
      this.initialize()
    },
    methods: {
    _P (value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    initialize () {
      let tdata=[];
      let ref = db.collection('customer').doc(this.$route.params.id).collection('products').doc(this.$route.params.proid).collection('sale').where("stt","==",1).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let tmpdata =doc.data();
          tmpdata.id =doc.id;
          tmpdata.qty = doc.data().qty;
          tmpdata.price = doc.data().price;
          tdata.push(tmpdata)
        });
        this.mydata=tdata;
      })
      .catch(err => {
        console.log('Error getting documents', err);
      });
    },
    editItem (item) {
      this.editedIndex = this.mydata.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      console.log(item)
    },
    deleteItem (item) {
      const index = this.mydata.indexOf(item)
      if ( confirm('Are you sure you want to delete this item ('+item.qty+' )?')) {
        db.collection('customer').doc(this.$route.params.id).collection('products').doc(this.$route.params.proid).collection('sale').doc(item.id).update({stt:0})
        this.mydata.splice(index, 1)
      }
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        // Object.assign(this.mydata[this.editedIndex], this.editedItem)
        let id=this.editedItem.id;
        delete this.editedItem.id;
        this.editedItem.qty =parseInt(this.editedItem.qty)
        this.editedItem.price =parseFloat(this.editedItem.price)
        let ref = db.collection('customer').doc(this.$route.params.id).collection('products').doc(this.$route.params.proid).collection('sale').doc(id).update(this.editedItem)
      } else {
        this.editedItem.qty =parseInt(this.editedItem.qty)
        this.editedItem.price =parseFloat(this.editedItem.price)
        let ref = db.collection('customer').doc(this.$route.params.id).collection('products').doc(this.$route.params.proid).collection('sale').add(this.editedItem)
      }
      this.initialize()
      this.close()
    },
    gotopageCustomCountPrice () {
      this.$router.push({ name: 'CustomCountPrice', params: { id:item.id  }})
    }
  }
}
</script>

<style>
.fontLao{
font-family: phetsarath ot !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomProductPriceCount.vue